import React, { useCallback, useState } from 'react';
import LoadingSkeleton from 'react-loading-skeleton';
import styled from 'styled-components';

const Hidden = styled.div`
  height: 0;
  position: absolute;
  overflow: hidden;
`;

const Wrapper = styled.div`
  line-height: normal !important;

  span {
    line-height: normal !important;
  }
`;

export default function Skeleton({ loading, width, children }: any) {
  const [height, ref] = useHeight();

  if (loading) {
    return (
      <React.Fragment>
        <LoadingSkeleton
          height={`${height}px`}
          width={width}
          wrapper={Wrapper}
        />
        <Hidden>
          <div ref={ref}>{children}</div>
        </Hidden>
      </React.Fragment>
    );
  }

  return children;
}

function useHeight(): [number, (node: any) => any] {
  const [height, setHeight] = useState(0);

  const ref = useCallback(node => {
    if (node !== null) {
      const realHeight =
        node.getBoundingClientRect().height || node.clientHeight;

      setHeight(realHeight | 0);
    }
  }, []);

  return [height, ref];
}
